<template>
  <div class="content-item amount">
    <h2 class="heading" :class="[isError && 'error']">How Many Cards Would You Like to Ship In this Order?</h2>
    <div class="row mb-4" style="justify-content: center">
      <div v-for="p in filteredPricing" :key="p.id" class="col-md-3 mb-4">
        <div class="amount-item" @click="selectedPrice = p" :class="[p.id === selectedPrice.id && 'selected']">
          <input type="radio" name="radio-amount1" :id="`radio1-amount${p.amount}`" :checked="p.amount === selectedPrice.amount" />
          <label :for="`radio1-amount${p.amount}`">
            <span v-text="numberWithSeparator(p.amount)" />
          </label>
        </div>
      </div>
    </div>
    <p>{{ chargableMessage }}</p>
  </div>
</template>

<script>
import { empty } from '@/utils';
import { debounce, isEmpty, isFunction } from 'lodash';
import { mapState } from 'vuex';
export default {
  name: 'Step13',
  props: {
    value: {
      type: Object,
    },
    step: {
      type: Number,
    },
  },
  data() {
    return {
      // isError: false,
      selectedPrice: {},
      extraBudget: 0,
      extraCards: 0,
    };
  },
  computed: {
    ...mapState({
      pricing: state => state.payment.pricing,
    }),
    filteredPricing() {
      console.log(this.pricing);
      return this.isPastor ? this.pricing.filter(p => ['1000', '2500', '5000', '7500', '10000', '15000', '20000'].includes(p.amount)) : this.pricing;
    },
    chargableMessage() {
      /* eslint-disable */
      this.extraBudget = 0;
      this.extraCards = 0;

      if (!this.isPastor) {
        return '';
      }
      const membership = this.$store.state.user.user.membership;
      // eslint-disable-next-line camelcase
      const remainingCards = membership ? membership.active_cards || 0 : 0;
      if (!this.selectedPrice.id || remainingCards >= this.selectedPrice.amount) {
        return '';
      } else if (remainingCards) {
        let amountTobePaid = this.selectedPrice.amount - remainingCards;
        let selectedPricing = [];

        for (let i = this.pricing.length - 1; i >= 0; i--) {
          while (amountTobePaid >= this.pricing[i].amount) {
            amountTobePaid -= this.pricing[i].amount;
            selectedPricing.push(this.pricing[i]);
          }
        }

        this.extraBudget = selectedPricing.reduce((s, a) => s + a.price, 0);
        this.extraCards = this.selectedPrice.amount - remainingCards;

        return `The cards remaining are not enough to order ${this.selectedPrice.amount}. You will be chared $${this.extraBudget} for ${
          this.selectedPrice.amount - remainingCards
        } missing cards by submitting the card order form.`;
      } else {
        this.extraBudget = this.selectedPrice.price;
        this.extraCards = this.selectedPrice.amount;
        return `You will be chared ${this.selectedPrice.currency}${this.selectedPrice.price} to order ${this.selectedPrice.amount} invitation cards`;
      }
    },
    isError() {
      return empty(this.selectedPrice);
    },
  },
  watch: {
    isError: {
      handler(value) {
        if (isFunction(this.doEmitErrorDebouned)) {
          this.doEmitErrorDebouned(value);
        } else {
          this.doEmitError(value);
        }
      },
      immediate: true,
    },
  },
  async created() {
    this.doEmitErrorDebouned = debounce(this.doEmitError, 400);

    await this.doInitData();
  },
  methods: {
    async doInitData() {
      if (isEmpty(this.pricing)) {
        await this.$store.dispatch('fetchPricing');
      }
    },
    numberWithSeparator(value) {
      return Number(value).toLocaleString();
    },
    submit() {
      if (this.isError) {
        this.$emit('onAnimated', [this.isError, this.step, 'Amount is required.']);
      } else {
        const amount = Number(this.selectedPrice.amount);
        this.$emit('input', {
          ...this.value,
          amount,
          extra_pay: this.extraBudget,
          extra_cards: this.extraCards,
        });
      }
    },
    doEmitError(value) {
      this.$emit('onInvalid', [value, this.step, 'Amount is required.']);
    },
    isNumber(evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

.
<style lang="scss" scoped>
.content-item {
  .heading.error {
    color: #e34343;
  }

  .form-input.error {
    border: 1px solid #e34343;
  }
  &.amount {
    .amount-item {
      border: 1px solid #4987c5;
      border-radius: 4px;
      padding: 0.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      &:hover {
        background: #4987c5;
        color: #fff;
      }
      &.selected {
        background: #4987c5;
        color: #fff;
      }

      input[type='radio'] {
        display: none;
      }
      label {
        cursor: pointer;
        margin-bottom: 0;
        font-weight: 700;
        // &:before {
        //   content: '$';
        //   margin-right: 0.2rem;
        // }
      }
    }
  }
}
</style>
